import Swiper from "swiper/bundle";
import "swiper/css";

export default class GridCarouselWrapper extends HTMLElement {

	constructor() {

		super();

		this.carouselEl = this.querySelector(".slider");
		this.slides = this.carouselEl.querySelectorAll(".slider-slide");
		/**
		 * All the dataset attributes
		 *
		 * @param	{Object}	this.data
		 * @param	{string}	this.data
		 */
		this.data = this.carouselEl.dataset;
		this.slidesPerView = parseFloat(this.data.slidesperview) || 1;
		this.anim = (this.data.animationType) ? this.data.animationType.toLowerCase() : "slide";
		this.modules = [];

		this.init();
	}

	init() {

		let gridCount = parseFloat(this.dataset.gridCols);
		let mdGridCount = this.dataset.mdGridCols ? parseFloat(this.dataset.mdGridCols) : null;
		let loops = this.data.loops !== undefined ? true : false;
		mdGridCount = mdGridCount ? mdGridCount : gridCount;

		/** Set up our carousel */
		this.carousel = new Swiper(this.carouselEl, {
			autoplay: false,
			breakpoints: {
				320: {
					slidesPerView: this.slidesPerView,
					centeredSlides: true,
					centerInsufficientSlides: true
				},
				768: {
					centeredSlides: false,
					slidesPerView: mdGridCount
				},
				1024: {
					slidesPerView: gridCount
				}
			},
			containerModifierClass: "slider-",
			slideActiveClass: "slide-active",
			slideClass: "slider-slide",
			slideDuplicateActiveClass: "slide-active-duplicate",
			slideDuplicateClass: "slide-duplicate",
			slideDuplicateNextClass: "slide-next-duplicate",
			slideDuplicatePrevClass: "slide-prev-duplicate",
			slidePrevClass: "slide-prev",
			slideNextClass: "slide-next",
			slideVisibleClass: "slide-visible",
			slidesPerView: gridCount,
			spaceBetween: 16,
			loop: loops,
			// modules: this.modules,
			observer: true,
			observeParents: true,
			loopedSlides: this.slides.length,
			allowSlideNext: true,
			allowSlidePrev: true,
			wrapperClass: "slider-slides",
			navigation: {
				disabledClass: "slider-button-disabled",
				enabled: true,
				hiddenClass: "slider-button-hidden",
				hideOnClick: false,
				lockClass: "slider-button-lock",
				navigationDisabledClass: "slider-navigation-disabled",
				nextEl: this.querySelector(".slider-button-next"),
				prevEl: this.querySelector(".slider-button-prev")
			},
			on: {
				init: (swiper) => {
					if (this.slides.length < 2) {
						let nav = this.querySelector('.slider-buttons')
						nav.style.display = 'none';
						swiper.destroy();
					}
					window.Zero.lazyLoad.update();
					window.Zero.animation.init();
				},
			}
		});
	}
}
